export const POST_LOGIN_REDIRECT_KEY = 'post_login_redirect_url';

/**
	Query parameter used by external systems to force the Okta
	login flow when deep-linking into fields
*/
export const FORCE_AUTH_QUERY_PARAM = 'auth';
export const FORCE_AUTH_OKTA_VALUE = 'okta';

export const setPostLoginRedirect = (url: string) =>
{
	localStorage.setItem(POST_LOGIN_REDIRECT_KEY, url);
};

export const popPostLoginRedirect = (): string | null =>
{
	const url = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
	if (url)
	{
		localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
	}
	return url;
};